<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
// 这里可以添加全局逻辑
</script>

<style>
@import '@/assets/styles/main.css';
</style>